import { Component, OnInit } from '@angular/core';
import {ModalController, NavParams} from "@ionic/angular";
import {AuthService} from "../../../../services/mygreencountry/auth.service";
import {StudentService} from "../../../../services/mygreencountry/student.service";

@Component({
  selector: 'app-changed-cabinet',
  templateUrl: './changed-cabinet.component.html',
  styleUrls: ['./changed-cabinet.component.scss'],
})
export class ChangedCabinetComponent  implements OnInit {

    public type: string = '';
    public isParent: boolean = false;

    constructor(private modalCtrl: ModalController,
                private navParams: NavParams,
                private authService: AuthService,
                private studentService: StudentService,) {
    }

    ngOnInit() {
        this.type = this.navParams.data['type'] ?? '';
        this.isParent = this.authService.isParent();

    }

    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

    goToParentDashboard() {
        this.studentService.goToParentDashboard();
    }

    logout(){
        this.authService.logout();
    }

}
